import React from 'react';
import { User } from '@supabase/supabase-js';
import Link from 'next/link';
import { FaMap, FaQuestion } from 'react-icons/fa';
import { Folder, FolderOpen, HomeIcon } from 'lucide-react';

const EmptyState: React.FC<{ user: User | null }> = ({ user }) => {
  return (
    <div className="flex flex-col w-full flex-auto overflow-hidden rounded-lg bg-shades-baseLighter backdrop-blur-md text-sm leading-6 shadow-lg ring-1 ring-gray-900/5 max-h-[calc(100vh-200px)] relative right-[1px] py-8">
      <div className="absolute top-0 left-0 p-4 flex items-center gap-x-2">
        <Link
          href="/"
          className="flex items-center gap-x-2 text-shades-text/75 hover:text-colors-green"
        >
          <HomeIcon className="w-5 h-5 " />
          <p className="text-base mt-0.5">Home</p>
        </Link>
      </div>
      <div className="text-center my-0 mt-24">
        <FolderOpen className="w-16 h-16 mx-auto text-shades-text/55" />
        <h3 className="mt-2 text-2xl font-semibold text-shades-text">
          No Saved Maps
        </h3>
        {!user ? (
          <>
            <p className=" text-sm text-shades-text/70">
              you must be logged in to save maps.
            </p>
            <div className="mt-4 flex flex-col gap-y-2 w-full justify-center items-center">
              <Link
                className="inline-flex items-center justify-center px-3 py-2 text-base w-24 text-center font-semibold rounded-md shadow-sm bg-colors-green hover:bg-colors-greenDark text-shades-base focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                href={'/login'}
              >
                Log in
              </Link>
              <div className="mt-24 flex gap-y-2">
                <p className="text-sm text-shades-text/85">New User?</p>
                <Link
                  className="inline-flex items-center text-sm ml-1 text-colors-green focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 hover:underline"
                  href={'/signup'}
                >
                  Sign Up
                </Link>
              </div>
            </div>
          </>
        ) : (
          <p className="mt-1 text-sm text-shades-text/85">
            You have not created any maps yet.
          </p>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
